
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions/[courseSlug]",
      function () {
        return require("private-next-pages/questions/[courseSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/questions/[courseSlug]"])
      });
    }
  